import React from "react";

const AdhesionForm = ({ onSubmit }) => {
  const [form, setForm] = React.useState({
    last_name: "",
    first_name: "",
    email: "",
    phone: ""
  });

  const [error, setError] = React.useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.email && !form.phone) {
      setError("Veuillez renseigner au moins un email ou un numéro de téléphone.");
      return;
    }

    setError("");
    onSubmit(form);
    setForm({ last_name: "", first_name: "", email: "", phone: "" });
  };

  return (
    <form onSubmit={handleSubmit} className="card shadow-sm border-0 p-4">
      <h4 className="fw-bold mb-4">Demande d’adhésion</h4>

      <div className="row g-3">
        <div className="col-md-6">
          <input
            type="text"
            name="last_name"
            className="form-control"
            placeholder="Nom"
            value={form.last_name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="col-md-6">
          <input
            type="text"
            name="first_name"
            className="form-control"
            placeholder="Prénom"
            value={form.first_name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="col-md-6">
          <input
            type="email"
            name="email"
            className="form-control"
            placeholder="Adresse mail"
            value={form.email}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-6">
          <input
            type="tel"
            name="phone"
            className="form-control"
            placeholder="Numéro de téléphone"
            value={form.phone}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              handleChange({ target: { name: "phone", value } });
            }}
            pattern="[0-9]{10}"
            maxLength={10}
            inputMode="numeric"
          />
        </div>
      </div>

      {error && (
        <div className="alert alert-danger mt-3">
          {error}
        </div>
      )}

      <div className="text-end mt-4">
        <button type="submit" className="btn btn-success">
          Envoyer la demande
        </button>
      </div>
    </form>
  );
};

export default AdhesionForm;
